import { map } from 'underscore';
import React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { ChevronRightRegular } from '@fluentui/react-icons';
import { TruncatedText } from './truncated-text';
import { useBreadcrumbStyles } from '../styles';
import { useFocusedEntityContext } from '../focused-entity-context';
import { Entity } from '../types';
import { geti18nStringTemplates } from '../helper';

export interface IBreadcrumbsProps {
  rootEntityTypeDisplayName: string;
  selectedEntity?: Entity;
  i18n: { getString: (key: string, params?: any) => string };
  className?: string;
  hasRootEntityFilter?: boolean;
}

export const Breadcrumbs = ({
  rootEntityTypeDisplayName,
  selectedEntity,
  i18n,
  hasRootEntityFilter,
  className,
}: IBreadcrumbsProps) => {
  const { focusedEntity, setFocusedEntity } = useFocusedEntityContext();

  const i18nTemplates = geti18nStringTemplates(i18n);

  const getEntityName = () => {
    if (focusedEntity) {
      if (focusedEntity === 'All') {
        return [];
      }
      if (focusedEntity.name) {
        return [focusedEntity.name];
      }
    }

    if (selectedEntity) {
      return [selectedEntity.name];
    }

    return [];
  };

  const styles = useBreadcrumbStyles();
  const entityName = getEntityName();
  const breadcrumbs = [
    hasRootEntityFilter
      ? i18nTemplates.filteredEntity(rootEntityTypeDisplayName)
      : i18nTemplates.allEntity(rootEntityTypeDisplayName),
    ...entityName,
  ];

  return (
    <div className={mergeClasses('scope-breadcrumb', styles.root, className)}>
      {map(breadcrumbs, (breadcrumb, index) => (
        <React.Fragment key={index}>
          {
            index === 0 && breadcrumbs.length > 1
              ? (
                <button
                  type="button"
                  onClick={() => setFocusedEntity('All')}
                  className={mergeClasses('scope-breadcrumb-show-all', styles.firstBreadcrumb)}
                >
                  {breadcrumb}
                </button>
              )
              : <TruncatedText content={breadcrumb} />
          }
          {
            index < breadcrumbs.length - 1
            && (
              <span className={styles.chevron}>
                <ChevronRightRegular />
              </span>
            )
          }
        </React.Fragment>
      ))}
    </div>
  );
};

Breadcrumbs.defaultProps = {
  selectedEntity: undefined,
  hasRootEntityFilter: false,
  className: '',
};
